<template>
    <svg :width="width" :height="height" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.368 13.296L0.888002 6.816L7.368 0.359999L8.568 1.56L3.936 5.952L14.04 5.952L14.04 7.68L3.936 7.68L8.568 12.096L7.368 13.296Z"
            fill="white"/>
    </svg>
</template>
<script>
export default {
    name: 'AtomIcArrow',
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    },
}
</script>
